import { 
  SignInButton, 
  SignOutButton, 
  useUser 
} from "@clerk/clerk-react";
import { useMutation, Authenticated, Unauthenticated, AuthLoading } from "convex/react";
import { api } from "../../../../backend/convex/_generated/api";
import { useEffect } from "react";

export function UserMenu() {
  const { user } = useUser();
  const storeUser = useMutation(api.users.store);

  useEffect(() => {
    if (user) {
      storeUser();
    }
  }, [user, storeUser]);

  return (
    <div className="flex items-center gap-4">
      <AuthLoading>
        <div className="px-4 py-2 text-sm font-medium text-muted-foreground">
          Loading...
        </div>
      </AuthLoading>
      <Unauthenticated>
        <SignInButton mode="modal">
          <button className="px-4 py-2 text-sm font-medium transition-colors border rounded-md bg-background hover:bg-accent hover:text-accent-foreground">
            Sign In
          </button>
        </SignInButton>
      </Unauthenticated>
      <Authenticated>
        <SignOutButton>
          <button className="px-4 py-2 text-sm font-medium transition-colors border rounded-md bg-background hover:bg-accent hover:text-accent-foreground">
            Sign Out
          </button>
        </SignOutButton>
      </Authenticated>
    </div>
  );
}

